import { GuestDetails } from '../../../guestDetails';
import { Entitlement, EntitlementHotlist, QuickEntitlement } from '../../models';
import { getActiveHotlistsForGuest } from '../../../hotlist/module';
import ImmutableMap from '../../../../language/ImmutableMap';
import { getErrorShortCircuit } from '../../../../core/redux/api/module';
import { ACTION_TYPE } from '../../../../core/redux/actionType';

export const enum FNF_PAGES {
  ENTITLEMENTS,
  RETURN_DAYS,
  RETURN_COMPLETION,
  REDEEM_DAYS,
  REDEEM_COMPLETION,
}

const getExternalId = (fnfEntitlement: Entitlement, guestEntitlements: QuickEntitlement[]) => {
  const foundEntitlement = guestEntitlements
    .find(ent => ent.entitlementId === fnfEntitlement.entitlementId);

  return foundEntitlement ? foundEntitlement.externalId : undefined;
};

/**
 * Given a Friends and Family entitlement, a guest, and a map of entitlement hotlists, we return
 * if that FnF qualifies as a hotlisted entitlement.
 * Logic:
 * -given the fnf entitlement, find the corresponding entitlement on the guest, and note its external ID
 * -on the guest, find the 'lift' entitlement with the same external ID but different entitlement ID
 * -check if the 'lift' entitlement is hotlisted and return result
 */
export const fnfIsHotlisted = (
  fnfEntitlement: Entitlement,
  guest: GuestDetails,
  hotlists: ImmutableMap<EntitlementHotlist[]>
): boolean => {
  const guestEntitlements: QuickEntitlement[] = (guest.entitlements || []);

  const externalId = getExternalId(fnfEntitlement, guestEntitlements);

  if(!externalId) {
    return false;
  }

  const linkedEntitlement =
    guestEntitlements
      .find(ent => ent.externalId === externalId && ent.entitlementId !== fnfEntitlement.entitlementId);

  if(!linkedEntitlement) {
    return false;
  }

  return !!getActiveHotlistsForGuest(guest, hotlists)
    .find(list => list.entitlementId === linkedEntitlement.entitlementId);
};

/**
 * Gets the error entitlement shares for the given Guest ID if it exists, and if the guest ID isn't undefined. Perfect
 * for if you don't know if you even have a guest.
 */
export const getErroredEntitlementShares = getErrorShortCircuit(ACTION_TYPE.ENTITLEMENT_SHARES_REQUEST);
